import { ItemIconSettings } from '../../../types/Admin/ItemIconTypes';

export const mapItemIconFields = (source: ItemIconSettings) => ({
  iconUrl: source.iconUrl && source.iconUrl !== '' ? source.iconUrl : '',
  iconFitMode: source.iconFitMode ?? 'scale',
  iconScale: source.iconScale ?? 100,
  iconPositionX: source.iconPositionX ?? 50,
  iconPositionY: source.iconPositionY ?? 50
});
